import React from 'react'
import { Box, styled, useTheme } from '@mui/material'
import MasterAppBar from '../master/components/MasterAppBar'
import SearchBarInput from '../master/components/SearchBarInput'
import Events from './components/Events'
import MainCalendar from './components/MainCalendar'
import CourseCards from './components/CourseCards'
import Footer from '../master/components/Footer'
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
function Dashboard() {
  const theme = useTheme();

  return (
    <ScopedCssBaseline>
      <Box>
        <MasterAppBar crumb={true} />
        <SearchBarInput />
        <MainBox>
          <Events sx={{ alignItems: 'center' }} />
          <MainCalendar />
          <CourseCards />
        </MainBox>
        <Footer />
      </Box>
    </ScopedCssBaseline>


  )
}
const MainBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  //gap: '5rem',
  justifyContent: 'space-around',
  //justifyItems: 'center',
  //justifyItems: 'center',
  alignItems: 'flext-start',
  marginTop: '3rem',
  flexWrap: 'wrap',
}));
export default Dashboard;

